import { render, staticRenderFns } from "./BusinessRegistrationTab.vue?vue&type=template&id=7a7b5166&scoped=true&"
import script from "./BusinessRegistrationTab.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistrationTab.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistrationTab.vue?vue&type=style&index=0&id=7a7b5166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b5166",
  null
  
)

export default component.exports